import React, { useState } from "react";
import { Avatar, Button } from "antd";
import { RightOutlined, LeftOutlined } from "@ant-design/icons";
// import "./BirthdayPerson.scss";
import cakeImg from "../../../../assets/images/dashboard/godisnji.svg";
import { ReactComponent as ArrowIcon } from "../../../../assets/images/dashboard/arrowRight.svg";
import { useTranslation } from "react-i18next";
interface BirthdayPerson {
  firstName: string;
  lastName: string;
  birthday: string;
  position: string;
}

interface Props {
  birthdays: BirthdayPerson[];
}

const AnniversariesSlider: React.FC<Props> = ({ birthdays }) => {
  const [page, setPage] = useState(0);
  const { t } = useTranslation();
  const itemsPerPage = 3;

  const totalPages = Math.ceil(birthdays?.length / itemsPerPage);
  const start = page * itemsPerPage;
  const visible = birthdays?.slice(start, start + itemsPerPage);

  return (
    <div className="birthday-box">
      <div className="birthday-header">
        <h3 className="birthday-title">
          {birthdays?.length} {t("Anniversary in the company")}
        </h3>
      </div>

      <div className="birthday-content">
        <div className="birthdayIcon">
          <img src={cakeImg} alt="cake" className="cake-icon" />
        </div>
        <div className="birthdaySlider">
          {page > 0 && (
            <Button
              type="text"
              className="leftIcon"
              icon={<ArrowIcon />}
              onClick={() => setPage(page - 1)}
            />
          )}

          <div className="birthday-list">
            {visible?.map((person, index) => (
              <div className="birthday-item" key={index}>
                <Avatar size={48} style={{ backgroundColor: "#3399cc" }}>
                  {person.firstName[0]}
                  {person.lastName[0]}
                </Avatar>
                <div className="name">
                  {person.firstName} {person.lastName[0]}.
                </div>
              </div>
            ))}
          </div>

          {page < totalPages - 1 && (
            <Button
              type="text"
              className="rightIcon"
              icon={<ArrowIcon />}
              onClick={() => setPage(page + 1)}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AnniversariesSlider;
